// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

import { Component,
         OnInit,
         ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'compare',
    encapsulation: ViewEncapsulation.None,
    template: require('./compare.component.html'),
    styles: [require('./compare.component.scss'),
                require('../styles/main.scss')]
})

export class CompareComponent {
	loading: boolean=false;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/compare/compare.component.ts